export default {
    "ERROR": {
        "GENERAL": "Hiba",
        "TOOMANYREQUEST": "Túl sok lekérés",
        "APIERROR": "API Hiba",
        "APIDEPLOY": "API frissítés alatt",
        "FAILED": "Sikertelen",
        "INVALID_ARTIST_NAME": "Érvénytelen előadó",
        "NO_ARTIST_NAME": "Érvénytelen előadó",
        "INVALID_PLACE_NAME": "Érvénytelen helyszín",
        "NO_PLACE_NAME": "Érvénytelen helyszín",
        "INVALID_START_DATE": "Érvénytelen időpont",
        "LINE_NR": "{line}. Sor",
    }
}


// WEBPACK FOOTER //
// ./src/i18n/messages/hu/error.js